import { makeVar, useReactiveVar } from '@apollo/client';

export const dataVar = makeVar({});

export const useData = () => useReactiveVar(dataVar);

export const updateData = (changes) => dataVar({ ...dataVar(), ...changes });

export const setData = (data = {}) => dataVar(data);
